import axios from 'axios'

const PostingService = {
  async get (params = {}) {
    return axios.get('ro/inter-branch-transfer/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('ro/reports/inter-branch-transfer/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`ro/inter-branch-transfer/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/inter-branch-transfer/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/inter-branch-transfer/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/inter-branch-transfer/postings/${data.id}`, { data })
  }
}

export default PostingService
